import React from "react";
import NavHeightAdjust from "../../../components/navbar/NavHeightAdjust";
import ProposalApprovalList from "./ProposalApprovalList";

const ProposalsApprovalPage = () => {
  return (
    <NavHeightAdjust>
      <ProposalApprovalList />
    </NavHeightAdjust>
  );
};

export default ProposalsApprovalPage;
